export const UPLOAD_MAX_TRIES = 1;
export const UPLOAD_TIMEOUT = 1000;
